import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import ReactGA from "react-ga";

const App = () => {
  const [rawData, setData] = useState({});
  const [posts, setPosts] = useState([]);
  const [calculatorsList, setCalcList] = useState([]);
  const { lang } = useParams();

  const location = useLocation();

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const drawerRef = useRef(null);

  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

  const handleScroll = () => {
    if (isDrawerOpen) {
      setDrawerOpen(false);
    }
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}${lang ? lang : "english"}?debug=true`)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setPosts(data["navigation"]);
        setCalcList(data["footer"]["Calculators"]);
        console.log(calculatorsList);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, [lang]);

  const shouldShowFooter = location.pathname !== "/english/fintragpt";
  const shouldShowFooter1 = location.pathname !== "/hindi/fintragpt";

  const handleDrawerClose = () => setDrawerOpen(false);

  return (
    <div className="App bg-white  h-full  flex-col">
      <div className="sticky top-0 w-full">
        <Navbar
          isDrawerOpen={isDrawerOpen}
          onDrawerClose={handleDrawerClose}
          drawerRef={drawerRef}
        />
      </div>
      <Outlet />
      {shouldShowFooter && shouldShowFooter1 && (
        <div className="bottom-0 w-screen ">
          <Footer
            applink={rawData.applink}
            nav={rawData.navigation}
            footer={rawData.footer}
          />
        </div>
      )}
    </div>
  );
};

export default App;
